// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-bar {
  height: 2px;
  background-color: rgba(0, 0, 0, 0);
  overflow: hidden;
  margin-left: 2px;
  margin-right: 4px;
}
.status-bar .active-bar {
  display: none;
}
.status-bar.active {
  background-color: rgba(0, 0, 0, 0);
}
.status-bar.active .active-bar {
  display: flex;
  width: 30%;
  height: 100%;
  background-color: var(--default-color);
  position: relative;
  animation: scroll 2s ease-in-out 0s infinite alternate;
}
@keyframes scroll {
from {
    left: -30%;
}
to {
    left: 100%;
}
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/statusBar/src/statusBar.vue","webpack://./statusBar.vue"],"names":[],"mappings":"AAIA;EACE,WAAA;EACA,kCAJc;EAKd,gBAAA;EACA,gBAAA;EACA,iBAAA;ACHF;ADKE;EACE,aAAA;ACHJ;ADME;EACE,kCAdY;ACUhB;ADMI;EACE,aAAA;EACA,UAjBW;EAkBX,YAAA;EACA,sCArBQ;EAsBR,kBAAA;EACA,sDAAA;ACJN;ADSA;AACE;IAAO,UAAA;ACLP;ADMA;IAAK,UAAA;ACHL;AACF","sourcesContent":["\n$activeColor: var(--default-color);\n$inactiveColor: #00000000;\n$activeBarWidth: 30%;\n.status-bar {\n  height: 2px;\n  background-color: $inactiveColor;\n  overflow: hidden;\n  margin-left: 2px;\n  margin-right: 4px;\n\n  .active-bar {\n    display: none;\n  }\n\n  &.active {\n    background-color: $inactiveColor;\n\n    .active-bar {\n      display: flex;\n      width: $activeBarWidth;\n      height: 100%;\n      background-color: $activeColor;\n      position: relative;\n      animation: scroll 2s ease-in-out 0s infinite alternate;\n    }\n  }\n}\n\n@keyframes scroll {\n  from { left: -$activeBarWidth; }\n  to { left: 100%; }\n}\n",".status-bar {\n  height: 2px;\n  background-color: rgba(0, 0, 0, 0);\n  overflow: hidden;\n  margin-left: 2px;\n  margin-right: 4px;\n}\n.status-bar .active-bar {\n  display: none;\n}\n.status-bar.active {\n  background-color: rgba(0, 0, 0, 0);\n}\n.status-bar.active .active-bar {\n  display: flex;\n  width: 30%;\n  height: 100%;\n  background-color: var(--default-color);\n  position: relative;\n  animation: scroll 2s ease-in-out 0s infinite alternate;\n}\n\n@keyframes scroll {\n  from {\n    left: -30%;\n  }\n  to {\n    left: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
